import { render, staticRenderFns } from "./imgCode.vue?vue&type=template&id=033e76c6&scoped=true"
import script from "./imgCode.vue?vue&type=script&lang=js"
export * from "./imgCode.vue?vue&type=script&lang=js"
import style0 from "./imgCode.vue?vue&type=style&index=0&id=033e76c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033e76c6",
  null
  
)

export default component.exports